var map = {
	"./01.png": 5220,
	"./02.png": 9492,
	"./03.png": 1174,
	"./04.png": 7131,
	"./05.png": 5904,
	"./06.png": 9519,
	"./07.png": 3803,
	"./08.png": 1827,
	"./09.png": 2355,
	"./10.png": 989,
	"./11.png": 7025,
	"./12.png": 5592,
	"./13.png": 9019,
	"./14.png": 5325,
	"./15.png": 6921,
	"./coin.png": 6336,
	"./dede_01.png": 9576,
	"./dede_02.png": 6393,
	"./dede_03.png": 3639,
	"./dede_04.png": 5975,
	"./dede_05.png": 9466,
	"./dede_06.png": 4240,
	"./dede_07.png": 6365,
	"./dede_08.png": 4867,
	"./dede_09.png": 4340,
	"./dede_10.png": 2019,
	"./dede_11.png": 5899,
	"./dede_12.png": 7919,
	"./dede_13.png": 6361,
	"./dede_14.png": 7346,
	"./dede_15.png": 7716,
	"./dede_coin.png": 7016
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5409;